<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#charging-station-map-container{
        position: absolute;
        top: 75px;
        left: 0px;
        right: 0px;
        bottom: 0px;

        div#charging-station-map {
            position: absolute;
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 0px;
        }
    }

    a[href^="http://maps.google.com/maps"] {
        display: none !important
    }

    a[href^="https://maps.google.com/maps"] {
        display: none !important
    }

    .gmnoprint a, .gmnoprint span, .gm-style-cc {
        display: none;
    }
</style>

<template>
    <div id="charging-station-map-container">
        <div id="charging-station-map">

        </div>
    </div>
</template>

<script>
    import { ChargingStationOperatorFilter } from '../../mixins/filters/ChargingStationOperatorFilter.js';
    import { EventBus } from '../../event-bus.js';
    import Geocode from '../../api/geocode';

    export default {
        props: {
            'latitude': {
                type: Number,
                default: function() {
                    return 50.05
                }
            },
            'longitude': {
                type: Number,
                default: function() {
                    return 14.35
                }
            },
            'zoom': {
                type: Number,
                default: function() {
                    return 8
                }
            },
        },

        mixins: [
            ChargingStationOperatorFilter
        ],

        computed: {
            clientLocation() {
                return this.$store.getters.getClientLocation;
            },

            minimumPower() {
                return this.$store.getters.getMinimumPowerFilter;
            },

            chargingStations() {
                return this.$store.getters.getChargingStations;
            },

            chargingStationsLoadStatus() {
                return this.$store.getters.getChargingStationsLoadStatus;
            },

            activeLocationFilter() {
                return this.$store.getters.getActiveLocationFilter;
            },

            operatorsFilter() {
                return this.$store.getters.getOperatorsFilter;
            },

            knownOperators() {
                return Object.keys(this.$store.getters.getChargingStationOperators || {}).filter(key => key !== 'OTHER');
            },

            previousLat() {
                return this.$store.getters.getLat;
            },

            previousLng() {
                return this.$store.getters.getLng;
            },

            previousZoom() {
                return this.$store.getters.getZoomLevel;
            },
        },

        watch: {
            '$route' (to, from) {
                if (to.name == 'charging-stations' && from.name == 'charging-station') {
                    if (this.clientLocation) {
                        this.$map.setCenter({
                            lat: this.clientLocation.latitude,
                            lng: this.clientLocation.longitude
                        });

                        this.$map.setZoom(14);

                        this.buildPersonMarker(this.clientLocation.latitude, this.clientLocation.longitude);
                    } else {
                        this.locateCurrentPosition();
                    }

                    document.title = this.$t('servicetype.chargingStation') + ' | Drivalia';

                    this.clearMarkersAnimation();
                    this.setCurrentPositionMarkerAnimation();

                    if (this.previousLat != 0.0 && this.previousLng != 0.0 && this.previousZoom != '') {
                        var latLng = new google.maps.LatLng(this.previousLat, this.previousLng);

                        this.$map.setZoom(this.previousZoom);
                        this.$map.panTo(latLng);
                    }
                }
            },

            /*
              Watches the chargingStations. When they are updated, clear the markers and build them
            */
            chargingStations() {
                this.clearMarkers();
                this.buildMarkers();
                this.processFilters();
            },

            activeLocationFilter() {
                this.processFilters();
            },
        },

        mounted() {
            this.$markers = [];
            this.$currentPositionMarker = null;
            this.$circle = null;

            this.$map = new google.maps.Map(document.getElementById('charging-station-map'), {
                center: {lat: this.latitude, lng: this.longitude},
                zoom: this.zoom,
                streetViewControl: false,
                styles: [
                    {
                        stylers: [{
                            saturation: -100
                        }]
                    },
                    {
                        featureType: "poi",
                        stylers: [{
                            visibility: "off"
                        }]
                    }
                ],
                fullscreenControl: false,
                mapTypeControl: false
            });


            if (this.$router.currentRoute.name == 'charging-stations') {
                if (this.clientLocation) {
                    this.$map.setCenter({
                        lat: this.clientLocation.latitude,
                        lng: this.clientLocation.longitude
                    });

                    this.$map.setZoom(14);

                    this.buildPersonMarker(this.clientLocation.latitude, this.clientLocation.longitude);
                } else {
                    this.locateCurrentPosition();
                }
            }

            this.clearMarkers();
            this.buildMarkers();

            EventBus.$on('charging-station-selected', function(chargingStation) {
                var latLng = new google.maps.LatLng(chargingStation.lat, chargingStation.lng);

                this.$map.setZoom(18);
                this.$map.panTo(latLng);

                setTimeout(() => {
                    if (this.$markers) {
                        var currentMarker = this.$markers.filter(function(elem) {
                            if (elem.chargingStation.id == chargingStation.id) {
                                return elem;
                            }
                        });

                        this.clearCurrentPositionMarkerAnimation();
                        currentMarker[0].setAnimation(google.maps.Animation.BOUNCE);
                    }
                }, 600);
            }.bind(this));

            EventBus.$on('charging-stations-search-submitted', function(activeMinimumPowerFilter) {
                this.clearMarkers();

                this.$store.dispatch('loadChargingStations', {
                    minimumPower: activeMinimumPowerFilter
                });

                this.buildMarkers();

                if (this.clientLocation.latitude && this.clientLocation.longitude) {
                    this.buildPersonMarker(this.clientLocation.latitude, this.clientLocation.longitude);

                    this.$map.setCenter({
                        lat: this.clientLocation.latitude,
                        lng: this.clientLocation.longitude
                    });

                    this.$map.setZoom(14);
                }
            }.bind(this));

            EventBus.$on('address-entered', function(addressData) {
                this.clearMarkers();

                this.$store.dispatch('loadChargingStations', {
                    minimumPower: this.minimumPower
                });

                this.buildMarkers();

                this.$map.setCenter({
                    lat: addressData.latitude,
                    lng: addressData.longitude
                });

                this.$map.setZoom(14);

                this.buildPersonMarker(addressData.latitude, addressData.longitude);
            }.bind(this));
        },

        methods: {
            locateCurrentPosition() {
                let chargingStationMap = this.$map;
                let self = this;

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        function (position) {
                            Geocode.getCountryCodeFromPosition(position)
                                .then((response) => {
                                    if (response != 'CZ') {
                                        chargingStationMap.setCenter({
                                            lat: 50.08804,
                                            lng: 14.42076
                                        });

                                        chargingStationMap.setZoom(14);
                                        self.buildPersonMarker(50.08804, 14.42076)
                                    } else {
                                        chargingStationMap.setCenter({
                                            lat: position.coords.latitude,
                                            lng: position.coords.longitude
                                        });

                                        chargingStationMap.setZoom(14);
                                        self.buildPersonMarker(position.coords.latitude, position.coords.longitude)
                                    }
                                })
                                .catch((error) => {
                                    console.log(error)
                                });
                        },
                        function (error) {
                            chargingStationMap.setZoom(14);
                            console.log(error.message);
                        }, {
                            enableHighAccuracy: true,
                            timeout: 60000
                        }
                    );
                } else {
                    console.log('Geolocation is not supported by this browser.');
                }
            },

            buildPersonMarker(lat, lng) {
                if (this.$currentPositionMarker) {
                    this.$currentPositionMarker.setMap(null);
                }

                var icon = {
                    url: '/img/person-marker-blue.svg',
                    scaledSize: new google.maps.Size(40, 40),
                }

                this.$currentPositionMarker = new google.maps.Marker({
                    position: {
                        lat: parseFloat(lat),
                        lng: parseFloat(lng)
                    },
                    map: this.$map,
                    icon: icon,
                    animation: google.maps.Animation.BOUNCE,
                });

                if (this.$circle) {
                    this.$circle.setMap(null);
                }
            },

            buildMarkers() {
                this.$markers = [];

                for (var i = 0; i < this.chargingStations.length; i++) {
                    if (this.chargingStations[i].status == 'under_construction') {
                        if (this.chargingStations[i].connectors_count > 3) {
                            var image = {
                                url: '/img/charging-station-under-construction-marker-bigger.svg',
                                scaledSize: new google.maps.Size(40, 58),
                            }
                        } else {
                            var image = {
                                url: '/img/charging-station-under-construction-marker-big.svg',
                                scaledSize: new google.maps.Size(26, 37),
                            }
                        }
                    } else {
                        if (this.chargingStations[i].max_power >= 300) {
                            if (this.chargingStations[i].connectors_count > 3) {
                                var image = {
                                    url: '/img/charging-station-petrol-blue-marker-bigger.svg',
                                    scaledSize: new google.maps.Size(40, 58),
                                }
                            } else {
                                var image = {
                                    url: '/img/charging-station-petrol-blue-marker-big.svg',
                                    scaledSize: new google.maps.Size(26, 37),
                                }
                            }
                        } else if (this.chargingStations[i].max_power >= 150) {
                            if (this.chargingStations[i].connectors_count > 3) {
                                var image = {
                                    url: '/img/charging-station-grass-green-marker-bigger.svg',
                                    scaledSize: new google.maps.Size(40, 58),
                                }
                            } else {
                                var image = {
                                    url: '/img/charging-station-grass-green-marker-big.svg',
                                    scaledSize: new google.maps.Size(26, 37),
                                }
                            }
                        } else if (this.chargingStations[i].max_power >= 50) {
                            if (this.chargingStations[i].connectors_count > 3) {
                                var image = {
                                    url: '/img/charging-station-aqua-blue-marker-bigger.svg',
                                    scaledSize: new google.maps.Size(40, 58),
                                }
                            } else {
                                var image = {
                                    url: '/img/charging-station-aqua-blue-marker-big.svg',
                                    scaledSize: new google.maps.Size(26, 37),
                                }
                            }
                        } else {
                            if (this.chargingStations[i].connectors_count > 3) {
                                var image = {
                                    url: '/img/charging-station-middle-orange-marker-bigger.svg',
                                    scaledSize: new google.maps.Size(40, 58),
                                }
                            } else {
                                var image = {
                                    url: '/img/charging-station-middle-orange-marker-big.svg',
                                    scaledSize: new google.maps.Size(26, 37),
                                }
                            }
                        }
                    }

                    if (this.chargingStations[i].latitude != null) {
                        var marker = new google.maps.Marker({
                            position: {
                                lat: parseFloat(this.chargingStations[i].latitude),
                                lng: parseFloat(this.chargingStations[i].longitude)
                            },
                            map: this.$map,
                            icon: image,
                            chargingStation: this.chargingStations[i]
                        });

                        let router = this.$router;
                        let store = this.$store;

                        var that = this;

                        marker.addListener('click', (function(marker) {
                            return function() {
                                that.clearCurrentPositionMarkerAnimation();
                                that.clearMarkersAnimation();

                                if (marker.getAnimation() != null) {
                                    marker.setAnimation(null);
                                } else {
                                    marker.setAnimation(google.maps.Animation.BOUNCE);
                                }

                                let center = this.map.getCenter();

                                store.dispatch('applyZoomLevel', this.map.getZoom());
                                store.dispatch('applyLat', center.lat());
                                store.dispatch('applyLng', center.lng());

                                router.push({ name: 'charging-station', params: { slug: this.chargingStation.slug } });
                            }
                        })(marker));


                        /*
                        marker.addListener('click', function() {
                            let center = this.map.getCenter();

                            store.dispatch('applyZoomLevel', this.map.getZoom());
                            store.dispatch('applyLat', center.lat());
                            store.dispatch('applyLng', center.lng());

                            router.push({ name: 'charging-station', params: { slug: this.chargingStation.slug } });
                        });
                        */

                        this.$markers.push(marker);
                    }
                }
            },

            setCurrentPositionMarkerAnimation() {
                if (this.$currentPositionMarker) {
                    this.$currentPositionMarker.setAnimation(google.maps.Animation.BOUNCE);
                }
            },

            clearCurrentPositionMarkerAnimation() {
                if (this.$currentPositionMarker) {
                    this.$currentPositionMarker.setAnimation(null);
                }
            },

            clearMarkersAnimation() {
                for (var i = 0; i < this.$markers.length; i++) {
                    this.$markers[i].setAnimation(null);
                }
            },

            clearMarkers() {
                for (var i = 0; i < this.$markers.length; i++) {
                    this.$markers[i].setMap(null);
                }
            },

            processFilters() {
                for (var i = 0; i < this.$markers.length; i++) {
                    if (this.operatorsFilter.length == 0) {
                        this.$markers[i].setMap(this.$map);
                    } else {
                        var operatorsPassed = false;

                        if (this.operatorsFilter.length != 0 && this.processChargingStationOperatorFilter(this.$markers[i].chargingStation, this.operatorsFilter, this.knownOperators)) {
                            operatorsPassed = true;
                        } else if (this.operatorsFilter.length == 0) {
                            operatorsPassed = true;
                        }

                        if (operatorsPassed) {
                            this.$markers[i].setMap(this.$map);
                        } else {
                            this.$markers[i].setMap(null);
                        }
                    }
                }
            },
        }
    }
</script>
